import { type WalletClient, type TransactionRequest, encodeFunctionData, parseUnits } from "viem";
import type { TransactionHash } from "@/types";
import { getGatewayContractAddress, TOKEN_CONFIG } from "@/config";
import { TOKEN_IDS } from "@/types";
import { estimateContractTransactionGas, writeContractTransaction } from "@/utils";
import { gatewayV1Abi } from "@/abi";

/**
 * Converts a string amount like "331.117868" into a BigInt, flooring everything after the decimal.
 */
// function toTruncatedBigIntFloor(amountStr: string, tokenId: (typeof TOKEN_IDS)[keyof typeof TOKEN_IDS]): bigint {
//     const decimals = TOKEN_CONFIG[tokenId].decimals;
//     const [whole] = (Number(Number(amountStr).toFixed(6)) * 10 ** 6 - 100).toString().split(".");
//     const scaled = BigInt(whole) * BigInt(10 ** (decimals - 6));
//     return scaled;
// }

export const prepareVaultWithdrawTransaction = async (
    amount: string, // already string
    walletClient: WalletClient,
): Promise<TransactionRequest> => {
    if (!walletClient.account) throw new Error("Wallet account is not available");
    if (!walletClient.chain?.id) throw new Error("Chain ID is not available");

    const amountBigInt = parseUnits(amount, TOKEN_CONFIG[TOKEN_IDS.IUSD].decimals);
    const contractAddress = getGatewayContractAddress(walletClient.chain.id);

    return {
        to: contractAddress,
        data: encodeFunctionData({
            abi: gatewayV1Abi,
            functionName: "unstake",
            args: [walletClient.account.address, amountBigInt],
        }),
    };
};

export const gatewayVaultWithdrawTransaction = async (
    amount: string,
    walletClient: WalletClient,
): Promise<TransactionHash> => {
    const txRequest = await prepareVaultWithdrawTransaction(amount, walletClient);
    return (await writeContractTransaction(walletClient, txRequest)) as TransactionHash;
};

export const estimateVaultWithdrawTransactionGas = async (
    amount: string,
    walletClient: WalletClient,
): Promise<bigint> => {
    const txRequest = await prepareVaultWithdrawTransaction(amount, walletClient);
    return estimateContractTransactionGas(walletClient, txRequest);
};
